// SceneManager.ts
import { Scene, WebGLRenderer } from 'three';

export class SceneManager {
  static scene: Scene;
  static gl: WebGLRenderer;
}
